module.exports = __webpack_public_path__ + "static/img/NATURALANTIOXIDANT.daf5f231.jpg";